import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconStatusbarMouseMove = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeMiterlimit: 1.5,
	clipRule: "evenodd",
	viewBox: "0 0 71 59",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 4.17,
		children: [/* @__PURE__ */ _jsx("rect", {
			width: 37.5,
			height: 54.167,
			x: 2.083,
			y: 2.083,
			rx: 15.207,
			ry: 15.207
		}), /* @__PURE__ */ _jsx("path", {
			strokeMiterlimit: 4,
			d: "M68.75 27.083H47.917M60.417 35.417h-12.5"
		})]
	})
});
export default SvgIconStatusbarMouseMove;
